<template lang="pug">
v-content
  gallery(:images="images" :index="index" @close="index = null" :options="{ closeOnSlideClick: true }")
  v-container.pa-0(fluid)
    v-row(no-gutters)
      v-col(cols=3 v-for="(i, n) in images" :key="n")
        v-img(:src="i" aspect-ratio=1 @click="index = n")
</template>

<script>
import VueGallery from 'vue-gallery'

export default {
  name: 'Photo',
  data() {
    return {
      index: null
    }
  },
  components: {
    gallery: VueGallery
  },
  computed: {
    images() {
      return [...Array(22).keys()].map(i =>
        require(`@/assets/photo/${i + 1}.jpg`)
      )
    }
  }
}
</script>